import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import {
  Badge,
  Chip,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import pages from '../../../router/routes';

interface Props {
  onActivate?: () => void;
  hasNew?: boolean;
}

export default function ReleaseNotesMenuItem({ onActivate, hasNew }: Props) {
  const navigate = useNavigate();

  return (
    <ListItemButton
      sx={{ borderRadius: 0 }}
      onClick={() => {
        navigate(pages.releaseNotes.path);
        onActivate?.();
      }}
    >
      <ListItemIcon>
        <Badge color='error' variant='dot' invisible={!hasNew}>
          <NewReleasesOutlinedIcon />
        </Badge>
      </ListItemIcon>
      <ListItemText primary='Release Notes' />
      {hasNew && (
        <Chip
          label='New'
          size='small'
          color='error'
          sx={{ height: 20, fontWeight: 600 }}
        />
      )}
    </ListItemButton>
  );
}
